
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MeasuringFactorDto, MeasureDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-measuring-factor',
  templateUrl: './measuring-factor.component.html',
  styleUrls: ['./measuring-factor.component.scss']
})
export class MeasuringFactorComponent implements OnChanges {

  @Input() measuringfactors: MeasuringFactorDto[];
  @Input() measures: MeasureDto[];
  measuringfactorForm: FormGroup;
  measuringfactorFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<MeasuringFactorDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredMeasuringFactor: Array<any> = [];
  status: boolean;
  selectedMeasuringFactorId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createMeasuringFactorForm();
  }

  createMeasuringFactorForm() {
    this.measuringfactorFormArray = this.fb.group({ MeasuringFactors: this.fb.array([]) });
    this.measuringfactorForm = this.fb.group({
      Acre: ['', Validators.required],
        MeasureId: this.selectedMeasuringFactorId,
        id: null
    });
  }


  // method to display measures
  setMeasuringFactor() {
    const control = this.measuringfactorFormArray.controls.MeasuringFactors as FormArray;
    this.filteredMeasuringFactor.forEach((e) => {
      control.push(
        this.fb.group({
          Acre: e.Acre,
          MeasureId: e.MeasureId,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addMeasuringFactor(measuringfactor: MeasuringFactorDto) {
    console.log('measuringfactor');
    const control = this.measuringfactorFormArray.controls.MeasuringFactors as FormArray;
    control.insert(
      0,
      this.fb.group({
        Acre: measuringfactor.Acre,
        MeasureId: this.selectedMeasuringFactorId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.measuringfactorFormArray.controls.MeasuringFactors as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter measuringfactor
  selectMeasure(event: string) {
    this.filteredMeasuringFactor = this.measuringfactors.filter((s) => s.MeasureId === event);
    this.selectedMeasuringFactorId = event;
    const control = this.measuringfactorFormArray.controls.MeasuringFactors as FormArray;

    if (this.filteredMeasuringFactor.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setMeasuringFactor();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteMeasuringFactor(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.measuringfactorFormArray.controls.MeasuringFactors as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.measuringfactors.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.measuringfactors[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: MeasuringFactorDto) {
    console.log('cumming');
    if(this.measuringfactorForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.measuringfactorFormArray.get('MeasuringFactors')['controls'][this.selectedIndex].patchValue({Acre: formValue.Acre});
    } else {
      this.addMeasuringFactor(formValue);
    }
    this.selectedIndex = null;
    this.measuringfactorForm.reset()
  }

  onEdit(index, value: MeasuringFactorDto) {
    this.selectedIndex = index;
    this.measuringfactorForm.patchValue({Acre: value.Acre});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.measuringfactorForm.reset();
  }


  onSubmit(formValue: any) {
    formValue.type = 'measuringfactor';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('measuringfactor');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}

